import { render, staticRenderFns } from "./AgentLayout.vue?vue&type=template&id=9387803a"
import script from "./AgentLayout.vue?vue&type=script&lang=js"
export * from "./AgentLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports